Ext.define('SA.view.map.menu.HighlightLocation', {
    alias: 'widget.map-menu-highlight-location',
    extend: 'SA.view.map.menu.MapMenuItem',

    text: 'Highlight Location',

    beforeMenuShow() {
        this.setChecked(this.getMapModel().isHighlightLocation());
    },

    checkHandler(me, checked) {
        var map = me.getMapModel();

        map.setHighlightLocation(checked);
    }
});